module.exports = __webpack_public_path__ + "358957709960bb33c023612f8d6c57c9.svg";